import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StatistikForventetTabListViewModel } from '../../models/StatistikForventetTabListViewModel';
import { StatistikService } from '../../statistik.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-statistik-igangvaerende-retforventettab-modal-ui',
    templateUrl: './statistik-igangvaerende-retforventettab-modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatistikIgangvaerendeRetforventettabModal implements OnInit {
    @Input() sagsid: number;
    forventedtablist$: Observable<StatistikForventetTabListViewModel[]>;

    constructor(
        private activeModal: NgbActiveModal,
        private statistikService: StatistikService,
    ) { }

    ngOnInit(): void {
        this.forventedtablist$ = this.statistikService.getForventedeTabListe(this.sagsid);
    }
    onDismiss() {
        this.activeModal.dismiss();
    }
}
